import React from "react";

const Desc = () => (
  <div className="site-description">
    <p>The 3rd generation of ROTZLER TITAN is the state of the art hoisting winch series offering outstanding performance, high safety standards and long service life.</p>
    <p>Please make use of the configurator to specify your ROTZLER TITAN!</p>
  </div>
);

export default Desc;



// WEBPACK FOOTER //
// ./src/components/description.js